module.exports = __webpack_public_path__ + "static/media/commercial_carousel.48ee69ef.jpg";